import { Chain, ChainOrAll } from "database";
import {
    EthNativeDenomination,
    PolygonNativeDenomination,
    SolNativeDenomination,
    BinanceNativeDenomination,
    TezosNativeDenomination,
    IcpNativeDenomination,
    ArbitrumNativeDenomination,
    AvalancheNativeDenomination,
    BitcoinNativeDenomination,
    LitecoinNativeDenomination,
    BitcoinCashNativeDenomination,
    CardanoNativeDenomination,
    XrpNativeDenomination,
    GnosisNativeDenomination,
    FantomNativeDenomination,
    EcreditsNativeDenomination,
    StellarNativeDenomination,
    VaraNativeDenomination,
    SepoliaNativeDenomination,
    RoninNativeDenomination,
    TronNativeDenomination,
    MoonriverNativeDenomination,
    CosmosNativeDenomination,
    AptosNativeDenomination,
    CasperNativeDenomination,
    ProvenanceNativeDenomination,
    OsmosisNativeDenomination,
    InjectiveNativeDenomination,
    BaseNativeDenomination,
} from "./constants";

export const getChainNativeDenomination = (chain: Chain) => {
    if (chain === Chain.ETHEREUM) {
        return EthNativeDenomination;
    }
    if (chain === Chain.SOLANA) {
        return SolNativeDenomination;
    }
    if (chain === Chain.POLYGON) {
        return PolygonNativeDenomination;
    }
    if (chain === Chain.BINANCE) {
        return BinanceNativeDenomination;
    }
    if (chain === Chain.TEZOS) {
        return TezosNativeDenomination;
    }
    if (chain === Chain.ICP) {
        return IcpNativeDenomination;
    }
    if (chain === Chain.ARBITRUM) {
        return ArbitrumNativeDenomination;
    }
    if (chain === Chain.AVALANCHE) {
        return AvalancheNativeDenomination;
    }
    if (chain === Chain.GNOSIS) {
        return GnosisNativeDenomination;
    }
    if (chain === Chain.BITCOIN) {
        return BitcoinNativeDenomination;
    }
    if (chain === Chain.LITECOIN) {
        return LitecoinNativeDenomination;
    }
    if (chain === Chain.BITCOIN_CASH) {
        return BitcoinCashNativeDenomination;
    }
    if (chain === Chain.CARDANO) {
        return CardanoNativeDenomination;
    }
    if (chain === Chain.XRP) {
        return XrpNativeDenomination;
    }
    if (chain === Chain.FANTOM) {
        return FantomNativeDenomination;
    }
    if (chain === Chain.ECREDITS) {
        return EcreditsNativeDenomination;
    }
    if (chain === Chain.STELLAR) {
        return StellarNativeDenomination;
    }
    if (chain === Chain.VARA) {
        return VaraNativeDenomination;
    }
    if (chain === Chain.SEPOLIA) {
        return SepoliaNativeDenomination;
    }
    if (chain === Chain.RONIN) {
        return RoninNativeDenomination;
    }
    if (chain === Chain.TRON) {
        return TronNativeDenomination;
    }
    if (chain === Chain.MOONRIVER) {
        return MoonriverNativeDenomination;
    }
    if (chain === Chain.COSMOS) {
        return CosmosNativeDenomination;
    }
    if (chain === Chain.APTOS) {
        return AptosNativeDenomination;
    }
    if (chain === Chain.CASPER) {
        return CasperNativeDenomination;
    }
    if (chain === Chain.PROVENANCE) {
        return ProvenanceNativeDenomination;
    }
    if (chain === Chain.OSMOSIS) {
        return OsmosisNativeDenomination;
    }
    if (chain === Chain.INJECTIVE) {
        return InjectiveNativeDenomination;
    }
    if (chain === Chain.BASE) {
        return BaseNativeDenomination;
    }

    return EthNativeDenomination;
};
export const getChainImage = (chain: ChainOrAll) => {
    if (chain === "ALL") {
        return "/images/icons/all.svg";
    }
    if (chain === Chain.ETHEREUM) {
        return "/images/icons/ethereum.svg";
    }
    if (chain === Chain.SOLANA) {
        return "https://seeklogo.com/images/S/solana-sol-logo-12828AD23D-seeklogo.com.png";
    }
    if (chain === Chain.POLYGON) {
        return "/images/icons/polygon.svg";
    }
    if (chain === Chain.BINANCE) {
        return "/images/icons/binance.svg";
    }
    if (chain === Chain.TEZOS) {
        return "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/tezos/info/logo.png";
    }
    if (chain === Chain.ICP) {
        return "https://assets.coingecko.com/coins/images/14495/small/Internet_Computer_logo.png";
    }
    if (chain === Chain.GNOSIS) {
        return "https://uploads-ssl.webflow.com/63692bf32544bee8b1836ea6/636a6e764bdb11a70341fab4_owl-forest.png";
    }
    if (chain === Chain.ARBITRUM) {
        return "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/arbitrum/info/logo.png";
    }
    if (chain === Chain.AVALANCHE) {
        return "https://assets.coingecko.com/coins/images/12559/small/Avalanche_Circle_RedWhite_Trans.png?1670992574";
    }
    if (chain === Chain.OPTIMISM) {
        return "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/optimism/info/logo.png";
    }
    if (chain === Chain.BITCOIN) {
        return "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/bitcoin/info/logo.png";
    }
    if (chain === Chain.LITECOIN) {
        return "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/litecoin/info/logo.png";
    }
    if (chain === Chain.BITCOIN_CASH) {
        return "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/bitcoincash/info/logo.png";
    }
    if (chain === Chain.CARDANO) {
        return "https://assets.coingecko.com/coins/images/975/small/cardano.png?1547034860";
    }
    if (chain === Chain.XRP) {
        return "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ripple/info/logo.png";
    }
    if (chain === Chain.FANTOM) {
        return "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/fantom/info/logo.png";
    }
    if (chain === Chain.ECREDITS) {
        return "https://assets.coingecko.com/coins/images/27575/small/ecs_1000x1000.png?1664685323";
    }
    if (chain === Chain.STELLAR) {
        return "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/stellar/info/logo.png";
    }
    if (chain === Chain.VARA) {
        return "https://assets.coingecko.com/coins/images/31458/standard/vara.jpeg?1696530272";
    }
    if (chain === Chain.SEPOLIA) {
        return "/images/icons/ethereum.svg";
    }
    if (chain === Chain.RONIN) {
        return "https://assets.coingecko.com/coins/images/20009/standard/Ronin_Mark_Blue.png?1707125056";
    }
    if (chain === Chain.TRON) {
        return "https://assets.coingecko.com/coins/images/1094/standard/tron-logo.png?1696502193";
    }
    if (chain === Chain.MOONRIVER) {
        return "https://assets.coingecko.com/coins/images/17984/standard/9285.png?1696517502";
    }
    if (chain === Chain.COSMOS) {
        return "https://assets.coingecko.com/coins/images/1481/standard/cosmos_hub.png?1696502525";
    }
    if (chain === Chain.APTOS) {
        return "https://assets.coingecko.com/coins/images/26455/standard/aptos_round.png?1696525528";
    }
    if (chain === Chain.CASPER) {
        return "https://assets-currency.kucoin.com/65a7a1dc2738b90001354d8c_CSPR%20logo.png";
    }
    if (chain === Chain.PROVENANCE) {
        return "https://img.cryptorank.io/coins/provenance_blockchain1677570040374.png";
    }
    if (chain === Chain.OSMOSIS) {
        return "https://assets.coingecko.com/coins/images/16724/standard/osmo.png?1696516298";
    }
    if (chain === Chain.INJECTIVE) {
        return "https://assets.coingecko.com/coins/images/12882/standard/Secondary_Symbol.png?1696512670";
    }
    if (chain === Chain.BASE) {
        return "/images/icons/base.svg";
    }
    return "";
};

export const getPlatformImage = (platform: string) => {
    if (platform === "UNISWAPV3") {
        return "https://assets.coingecko.com/coins/images/12504/small/uni.jpg?1687143398";
    }
    if (platform === "1_INCH") {
        return "https://assets.coingecko.com/coins/images/13469/small/1inch-token.png?1608803028";
    }
    if (platform === "SUSHISWAP") {
        return "https://assets.coingecko.com/markets/images/576/small/2048x2048_Logo.png?1609208464";
    }
    if (platform === "AAVE") {
        return "https://assets.coingecko.com/coins/images/12645/small/AAVE.png?1601374110";
    }
    if (platform === "METAMASK") {
        return "https://cdn.iconscout.com/icon/free/png-256/free-metamask-2728406-2261817.png";
    }
    return "";
};
